import React from 'react';
import Grid from "@mui/material/Grid";
import {AccordionDetails, Button} from "@mui/material";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import clsx from "clsx";
import { Alert, AlertTitle } from '@mui/material';

const FinalStep = ({setTipoPaziente, setNumPaziente, setStep}) => {
	const classes = BaseStyle();
	return (
		<React.Fragment>
			<AccordionDetails>
				<Grid container spacing={3}>
					<Grid item xs={12} className={classes.flexRight}>
						<Button color={"primary"} variant={"contained"} disableElevation
						        style={{borderRadius: 24}}
						        className={clsx(classes.roundButton, classes.margin1)}
						        onClick={() => {
							        setNumPaziente(prevState => ++prevState)
							        setTipoPaziente("contattistretti.")
							        setStep(0)
						        }}>
							<b>Aggiungi contatto non convivente</b>
						</Button>
						<Button color={"primary"} variant={"contained"} disableElevation
						        style={{borderRadius: 24}}
						        className={clsx(classes.roundButton, classes.margin1)}
						        onClick={() => {
							        setTipoPaziente("contatticonviventi.")
							        setNumPaziente(prevState => ++prevState)
							        setStep(0)
						        }}>
							<b>Aggiungi contatto convivente</b>
						</Button>
					</Grid>
					<Grid item xs={12}>
						<Alert severity="info" style={{borderRadius: 24, margin: 4}}>
							<AlertTitle><b>Hai finito il lavoro?</b></AlertTitle>
							Ottimo, clicca su "Ho finito! 💪" e torna indiero alla gestione dei tamponi. Potrai così effettuare
							nuovamente un'intervista.
						</Alert>
					</Grid>
				</Grid>
			</AccordionDetails>
		</React.Fragment>
	);
}

export default React.memo(FinalStep)
